import { useState } from "react";
import {
  addDoc,
  collection,
  deleteDoc,
  doc,
  serverTimestamp,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../firebase/config";
import { useCollection } from "../../hooks/useCollection";
import ImageUploader from "../../components/admin/ImageUploader";

const emptyForm = { name: "", imageUrl: "", order: 0 };

export default function ClientsAdmin() {
  const { items, loading } = useCollection("clients", "order", "asc");
  const [form, setForm] = useState(emptyForm);
  const [editingId, setEditingId] = useState(null);
  const [saving, setSaving] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const reset = () => {
    setForm(emptyForm);
    setEditingId(null);
  };

  const handleEdit = (item) => {
    setEditingId(item.id);
    setForm({
      name: item.name || "",
      imageUrl: item.imageUrl || "",
      order: item.order ?? 0,
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = {
        ...form,
        order: Number(form.order) || 0,
        updatedAt: serverTimestamp(),
      };
      if (editingId) {
        await updateDoc(doc(db, "clients", editingId), payload);
      } else {
        await addDoc(collection(db, "clients"), {
          ...payload,
          createdAt: serverTimestamp(),
        });
      }
      reset();
    } catch (err) {
      alert(`บันทึกไม่สำเร็จ: ${err.message}`);
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async (item) => {
    if (!window.confirm(`ลบ "${item.name}"?`)) return;
    await deleteDoc(doc(db, "clients", item.id));
  };

  return (
    <div>
      <h2 className="mb-4">จัดการ Alliance (โลโก้พันธมิตร)</h2>

      <div className="card shadow-sm mb-4">
        <div className="card-body">
          <h5 className="card-title mb-3">
            {editingId ? "แก้ไขโลโก้" : "เพิ่มโลโก้ใหม่"}
          </h5>
          <form onSubmit={handleSubmit}>
            <div className="row g-3">
              <div className="col-md-8">
                <label className="form-label">ชื่อองค์กร</label>
                <input
                  className="form-control"
                  value={form.name}
                  onChange={update("name")}
                  required
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">ลำดับ</label>
                <input
                  type="number"
                  className="form-control"
                  value={form.order}
                  onChange={update("order")}
                />
              </div>
              <div className="col-12">
                <label className="form-label">โลโก้</label>
                <ImageUploader
                  value={form.imageUrl}
                  onChange={(url) => setForm({ ...form, imageUrl: url })}
                />
              </div>
            </div>
            <div className="mt-3 d-flex gap-2">
              <button className="btn btn-primary" disabled={saving}>
                {saving ? "กำลังบันทึก..." : editingId ? "บันทึก" : "เพิ่ม"}
              </button>
              {editingId && (
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={reset}
                >
                  ยกเลิก
                </button>
              )}
            </div>
          </form>
        </div>
      </div>

      <div className="card shadow-sm">
        <div className="card-body">
          <h5 className="card-title mb-3">รายการ ({items.length})</h5>
          {loading ? (
            <div>กำลังโหลด...</div>
          ) : items.length === 0 ? (
            <div className="text-muted">ยังไม่มีโลโก้</div>
          ) : (
            <table className="table align-middle">
              <thead>
                <tr>
                  <th style={{ width: 100 }}>โลโก้</th>
                  <th>ชื่อ</th>
                  <th style={{ width: 80 }}>ลำดับ</th>
                  <th style={{ width: 180 }}></th>
                </tr>
              </thead>
              <tbody>
                {items.map((item) => (
                  <tr key={item.id}>
                    <td>
                      {item.imageUrl && (
                        <img
                          src={item.imageUrl}
                          alt=""
                          style={{ width: 80, height: 60, objectFit: "contain" }}
                        />
                      )}
                    </td>
                    <td>{item.name}</td>
                    <td>{item.order ?? 0}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-outline-primary me-2"
                        onClick={() => handleEdit(item)}
                      >
                        แก้ไข
                      </button>
                      <button
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => handleDelete(item)}
                      >
                        ลบ
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}
